import { createStyles } from '@material-ui/core/styles';

export default createStyles({
    gridContainer: {
        height: 'calc(100% - 120px)'
    },
    parentContainer: {
        float: 'left',
        // padding: 2,
        margin: 15,
        height: 'calc(100% - 86px)',
        width: '98%'
    },
    summaryPanelContainer: {
        display: 'flex',
        padding: 2,
        height: 'calc(100% - 112px)',
    },
    summaryPanelGrid: {
        margin: 15,
    },
    grid: {
        height: '100%',
        width: '100%',
        maxWidth: '100% !important',

    },
    lineDetailIcon: {
        cursor: 'pointer'
    },
    disabledIcon: {
        color: '#AAA !important',
    },
    anchor: {

    },
    actionButtonIcon: {

    }
});
